import assign from 'lodash/assign';
import curry from 'lodash/curry';
import filter from 'lodash/filter';
import ngTranslate from 'angular-translate';

import { SearchServiceModule } from 'services/data/search.service';

import template from './search.html';
import './search.scss';

const isListOf = (type, locationPath) => {
    return RegExp(`${type}/list`, 'i').test(locationPath);
};

export const setDefaultSearchAttributes = (path) => {
    if (isListOf('customer', path)) {
        return { restrictSearchableAttributes: ['firstName', 'lastName', 'company', 'emailAddress'] };
    }
    if (isListOf('order', path)) {
        const orderAttrs = [
            'orderNumber',
            'placedBy.firstName',
            'placedBy.lastName',
            'placedBy.emailAddress',
            'placedBy.company'
        ];
        return { restrictSearchableAttributes: orderAttrs };
    }
    if (isListOf('product', path)) {
        return { restrictSearchableAttributes: ['name', 'seo.friendlyName', 'productVariants.sku'] };
    }
    return { restrictSearchableAttributes: 'name' };
};

export const SearchDirectiveModule = angular
    .module('app.components.search', [
        SearchServiceModule,
        ngTranslate
    ]).directive('search', ($window, searchService, $location, $timeout) => {
        return {
            restrict: 'E',
            template,
            controllerAs: 'searchCtrl',
            scope: {
                searchFunction: '&?',
                pageController: '<',
                searchDelay: '<'
            },
            controller: function searchController($scope, $element, $attrs) {
                var $searchInput = $('#searchInput');
                var defaultOptions = setDefaultSearchAttributes($location.$$path);

                var options = null;
                var oldPageChange = null;
                var oldSortChange = null;
                var vm = {
                    searchOpen: false,
                    searchDelay: $scope.searchDelay || 0,
                    query: '',
                    isMobile: $window.matchMedia('(max-width: 599px)'),
                    translations: {
                        COUNT: `<span class="search-results__count">
                                    {$ctrl.grid.pageController.options.paging.totalItemCount}}
                                </span>
                        `,
                        QUERY: '<span class="search-results__query">{{searchCtrl.query}}</span>'
                    },
                    toggleSearch,
                    search,
                    reset
                };

                vm = assign(this, vm);

                $attrs.$observe('options', (res) => {
                    if (res && angular.isString(res)) {
                        options = JSON.parse(res);
                    }
                });

                $attrs.$observe('defaultOptions', (res) => {
                    if (res && angular.isString(res)) {
                        defaultOptions = JSON.parse(res);
                    }
                });

                function toggleSearch() {
                    vm.searchOpen = !vm.searchOpen;
                    if (vm.searchOpen) {
                        vm.query = '';

                        //200ms to wait until transition animation finishes
                        $timeout(() => {
                            $searchInput.focus();
                        }, 200);
                    } else {
                        reset();
                    }
                }

                function search(searchOptions) {
                    options = searchOptions || options;
                    $window.scrollTo(0, 0);
                    vm.searchInitialized = true;
                    searchPage('search', 1, 25, null);
                }

                function searchPage(type, page, count, sort) {
                    page = (page - 1) || 0;
                    count = count || 25;

                    if (sort != null) {
                        var splitSort = sort[0].split(' ');
                        sort = `${$attrs.index}_${splitSort[0]}_${splitSort[1]}`.toLowerCase();
                        delete options.restrictSearchableAttributes;
                    }

                    options = options || defaultOptions;
                    options.page = page;
                    options.hitsPerPage = count;
                    $scope.pageController.grid.options.isLoading = true;

                    const results = $scope.searchFunction ?
                        $scope.searchFunction({
                            params: {
                                search: vm.query,
                                sort,
                                count,
                                page
                            }
                        }) :
                        searchService.search(sort || $attrs.index, vm.query, options, false);

                    results.then((res) => {
                        //Overwrite grid functions until grid is sorted, then revert to normal
                        if (!oldPageChange) {
                            oldPageChange = $scope.pageController.grid.options.paging.onPageChange;
                        }
                        if (!oldSortChange) {
                            oldSortChange = $scope.pageController.grid.options.sorting.onSortChange;
                        }
                        $scope.pageController.grid.options.paging.onPageChange = curry(searchPage)('page');
                        $scope.pageController.grid.options.sorting.onSortChange = curry(searchPage)('sort');

                        $scope.pageController.grid.options.paging.currentPage = page + 1;

                        let response;
                        if ($scope.searchFunction) {
                            response = res;
                        } else {
                            response = {
                                items: res.hits,
                                totalCount: res.nbHits
                            };
                        }

                        $scope.pageController.onDataResponse(response, type || 'page');

                        $scope.pageController.grid.selected =
                            filter($scope.pageController.grid.selected, (item) => {
                                for (let i = 0; i < $scope.pageController.grid.items.length; i++) {
                                    if (item.id === $scope.pageController.grid.items[i].id) {
                                        return true;
                                    }
                                }
                                return false;
                            });
                    });
                }

                function reset() {
                    vm.searchInitialized = false;
                    vm.searchOpen = false;
                    vm.query = '';
                    options = defaultOptions || options;

                    if (!oldPageChange || !oldSortChange) {
                        let searchFilter = $location.search().filter;
                        searchFilter = searchFilter && searchFilter !== 'All' ? `state eq "${searchFilter}"` : null;
                        $scope.pageController.setFilter(searchFilter);
                        $location.search({ searchFilter });
                    }

                    oldPageChange = null;
                    oldSortChange = null;

                    $scope.pageController.grid.options.sorting.onSortChange(undefined, undefined, undefined);
                }
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/search/search.directive.js